import { paginatorData } from '@/components/Table/types/pagination';
import { useState } from 'react';

export const usePaginator = () => {
  const [paginator, setPaginator] = useState<paginatorData>({
    count: 50,
    page: 1,
  });

  return {
    setPaginator,
    paginator,
  };
};
